import { takeLatest, put, select } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpGet, httpDelete, httpPut } from '../core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { contractPath, contractDetailPath, contractEditPath, homePath } from 'routes'

// import r from 'reactotron-react-js'

const CLEAR_CONTRACT_DATA = 'CLEAR_CONTRACT_DATA'
const FETCH_CONTRACT = makeKeys('FETCH_CONTRACT')
const CREATE_CONTRACT = 'CREATE_CONTRACT'
const UPDATE_CONTRACT = 'UPDATE_CONTRACT'
const SUBMIT_CONTRACT = 'SUBMIT_CONTRACT'
const CHECKED_CONTRACT = 'CHECKED_CONTRACT'
const DELETE_CONTRACT = 'DELETE_CONTRACT'
const RESUBMIT_CONTRACT = 'RESUBMIT_CONTRACT'
const UPLOAD_ATTACHMENTS_CONTRACT = 'UPLOAD_ATTACHMENTS_CONTRACT'
const GET_CONTRACT_DETAIL = makeKeys('GET_CONTRACT_DETAIL')
const FETCH_PO_COMPLETE_FOR_CONTRACT = makeKeys('FETCH_PO_COMPLETE_FOR_CONTRACT')
const GET_PO_COMPLETE_DETAIL_FOR_CONTRACT = makeKeys('GET_PO_COMPLETE_DETAIL_FOR_CONTRACT')
const GET_OPTION_CONTRACT = makeKeys('GET_OPTION_CONTRACT')
const GET_OPTION_TYPE_OF_CONTRACT = makeKeys('GET_OPTION_TYPE_OF_CONTRACT')
const GET_OPTION_AMOUNT_OF_PAYMENT_TYPE = makeKeys('GET_OPTION_AMOUNT_OF_PAYMENT_TYPE')
const SELECT_PO = 'SELECT_PO'
const CLEAR_SEARCH_PO = 'CLEAR_SEARCH_PO'
const GET_CONTRACT_WORKFLOW_VIEW_MODE = makeKeys('GET_CONTRACT_WORKFLOW_VIEW_MODE')
const GET_CONTRACT_WORKFLOW_EDIT_MODE = makeKeys('GET_CONTRACT_WORKFLOW_EDIT_MODE')
const APPROVE_ACTION_CONTRACT = 'APPROVE_ACTION_CONTRACT'

export const clearContractData = makeAction(CLEAR_CONTRACT_DATA)
export const fetchContract = makeAction(FETCH_CONTRACT.REQUEST, 'query')
export const createContract = makeAction(CREATE_CONTRACT, 'data', 'history', 'isSubmit')
export const updateContract = makeAction(UPDATE_CONTRACT, 'data', 'history', 'isSubmit')
export const submitContract = makeAction(SUBMIT_CONTRACT, 'data', 'history')
export const checkedContract = makeAction(CHECKED_CONTRACT, 'data', 'history')
export const deleteContract = makeAction(DELETE_CONTRACT, 'contractId', 'history')
export const resubmitContract = makeAction(RESUBMIT_CONTRACT, 'data', 'history')
export const uploadAttachmentsContract = makeAction(UPLOAD_ATTACHMENTS_CONTRACT, 'data', 'history', 'isSubmit')
export const getContractDetail = makeAction(GET_CONTRACT_DETAIL.REQUEST, 'id', 'history', 'isEdit')
export const fetchPOComplete = makeAction(FETCH_PO_COMPLETE_FOR_CONTRACT.REQUEST, 'dataSearch')
export const gethPOCompleteDetail = makeAction(GET_PO_COMPLETE_DETAIL_FOR_CONTRACT.REQUEST, 'poId')
export const gethOptionContract = makeAction(GET_OPTION_CONTRACT.REQUEST)
export const gethOptionTypeOfContract = makeAction(GET_OPTION_TYPE_OF_CONTRACT.REQUEST)
export const gethOptionAOPT = makeAction(GET_OPTION_AMOUNT_OF_PAYMENT_TYPE.REQUEST)
export const setSelectPO = makeAction(SELECT_PO, 'data')
export const clearSearchPO = makeAction(CLEAR_SEARCH_PO)
export const getContractWorkflowViewMode = makeAction(GET_CONTRACT_WORKFLOW_VIEW_MODE.REQUEST, 'contractId')
export const getContractWorkflowEditMode = makeAction(GET_CONTRACT_WORKFLOW_EDIT_MODE.REQUEST, 'data')
export const approveActionContract = makeAction(APPROVE_ACTION_CONTRACT, 'data', 'history')

const fetchContractSuccess = makeAction(FETCH_CONTRACT.SUCCESS, 'data')
const getContractDetailSuccess = makeAction(GET_CONTRACT_DETAIL.SUCCESS, 'data')
const fetchPOCompleteSuccess = makeAction(FETCH_PO_COMPLETE_FOR_CONTRACT.SUCCESS, 'data')
const gethPOCompleteDetailSuccess = makeAction(GET_PO_COMPLETE_DETAIL_FOR_CONTRACT.SUCCESS, 'data')
const gethOptionContractSuccess = makeAction(GET_OPTION_CONTRACT.SUCCESS, 'data')
const gethOptionTypeOfContractSuccess = makeAction(GET_OPTION_TYPE_OF_CONTRACT.SUCCESS, 'data')
const gethOptionAOPTSuccess = makeAction(GET_OPTION_AMOUNT_OF_PAYMENT_TYPE.SUCCESS, 'data')
const getContractWorkflowViewModeSuccess = makeAction(GET_CONTRACT_WORKFLOW_VIEW_MODE.SUCCESS, 'data')
const getContractWorkflowEditModeSuccess = makeAction(GET_CONTRACT_WORKFLOW_EDIT_MODE.SUCCESS, 'data')

const basePath = path => path ? urlWithPrefix(`contracts/${path}`) : urlWithPrefix('contracts')
const multipartHeader = { 'Content-Type': 'multipart/form-data', }

function* fetchContractRequest(action) {
  const { query } = action.payload
  let filter = JSON.parse(JSON.stringify(query.filter || {}))
  let key = query.search
  try {
    if (filter) {
      let vendor = filter.vendor ? filter.vendor.split(':') : []
      if (vendor.length > 0) {
        filter.vendorCode = vendor[0] ? vendor[0].trim() : null
        filter.vendorName = vendor[1] ? vendor[1].trim() : null
      }
      //set project
      let p = ''
      if (filter.projectId && Array.isArray(filter.projectId)) {
        filter.projectId.forEach(i => {
          p += ',' + i
        })
        p = p.substring(1)
        filter.projectId = p
      }
    }
    yield put(appLoading())
    const response = yield httpGet(basePath(), { ...filter, key: key ? key.key : '', page: query.page, size: query.size })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchContractSuccess(response.data))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(fetchContract(query))
    } else {
      if (e && e.data && e.data.message) {
        yield put(toastError(e.data.message))
      } else {
        yield put(toastError('Load contracts data error!'))
      }
    }
  }
}

function* createContractRequest(action) {
  const { data, history, isSubmit } = action.payload
  try {
    yield put(appLoading('Save Contract'))
    if (!(data.typeOfContract && data.typeOfContract.find(x => x.toLowerCase() == 'tc06'))) {
      data.typeOfContractOther = null
    }
    const response = yield httpPost(basePath(), data)
    if (response.status >= 200 && response.status < 300) {
      yield put(uploadAttachmentsContract({ ...data, id: response.data }, history, isSubmit))
    }
    yield put(appLoaded())
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Save Contract fail.'))
    }
    yield put(appLoaded())
  }
}

function* updateContractRequest(action) {
  const { data, history, isSubmit } = action.payload
  try {
    yield put(appLoading('Save Contract'))
    if (!(data.typeOfContract && data.typeOfContract.find(x => x.toLowerCase() == 'tc06'))) {
      data.typeOfContractOther = null
    }
    const response = yield httpPut(basePath(`${data.id}`), data)
    if (response.status >= 200 && response.status < 300) {
      yield put(uploadAttachmentsContract(data, history, isSubmit))
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Save Contract fail.'))
    }
    yield put(appLoaded())
  }
}

function* submitContractRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading('Submit Contract'))
    const response = yield httpPost(basePath(`${data.id}/submit`), data)
    if (response.status >= 200 && response.status < 300) {
      history.push(contractPath)
      yield put(toastSuccess('Submit Contract success.'))
    }
    yield put(appLoaded())
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Submit Contract fail.'))
    }
    yield put(appLoaded())
  }
}

function* resubmitContractRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading('Re-Submit Contract'))
    const response = yield httpPost(basePath('reSubmit'), { docId: data.id, sn: data.sn, comment: data.actionComment })
    if (response.status >= 200 && response.status < 300) {
      if(response.data.success){
        history.push(contractPath)
        yield put(toastSuccess('Re-Submit Contract success.'))
      }else{
        yield put(toastError(response.data.message))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Re-Submit Contract fail.'))
    }
    yield put(appLoaded())
  }
}

function* checkedContractRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading('Check Contract'))
    const response = yield httpPut(basePath(`${data.id}/checked`))
    if (response.status >= 200 && response.status < 300) {
      history.push(contractPath)
      yield put(toastSuccess('Check Contract success.'))
    }
    yield put(appLoaded())
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Check Contract fail.'))
    }
    yield put(appLoaded())
  }
}

function* uploadAttachmentsContractRequest(action) {
  const { data, history, isSubmit } = action.payload
  try {
    yield put(appLoading('Upload Attachments'))
    var attachmentsData = {}
    if (data.ct01 && data.ct01.length > 0) attachmentsData.ct01 = data.ct01
    if (data.ct02 && data.ct02.length > 0) attachmentsData.ct02 = data.ct02
    if (data.ct03 && data.ct03.length > 0) attachmentsData.ct03 = data.ct03
    if (data.ct04 && data.ct04.length > 0) attachmentsData.ct04 = data.ct04
    if (data.ct05 && data.ct05.length > 0) attachmentsData.ct05 = data.ct05
    if (data.ct06 && data.ct06.length > 0) attachmentsData.ct06 = data.ct06
    if (data.ct11 && data.ct11.length > 0) attachmentsData.ct11 = data.ct11
    if (data.ct12 && data.ct12.length > 0) attachmentsData.ct12 = data.ct12
    if (data.ct13 && data.ct13.length > 0) attachmentsData.ct13 = data.ct13
    if (data.ct14 && data.ct14.length > 0) attachmentsData.ct14 = data.ct14
    if (Object.keys(attachmentsData).length) {
      const response = yield httpPost(basePath(`${data.id}/attachments`), attachmentsData, multipartHeader)
      if (response.status >= 200 && response.status < 300) {
        if (isSubmit) {
          if (data.status == 5) {
            yield put(resubmitContract(data, history))
          } else {
            if (data.forCheck) {
              yield put(checkedContract(data, history))
            } else {
              yield put(submitContract(data, history))
            }
          }
        } else {
          history.push(contractPath)
          yield put(toastSuccess('Save Contract success.'))
        }
      }
    } else {
      if (isSubmit) {
        if (data.status == 5) {
          yield put(resubmitContract(data, history))
        } else {
          if (data.forCheck) {
            yield put(checkedContract(data, history))
          } else {
            yield put(submitContract(data, history))
          }
        }
      } else {
        history.push(contractPath)
        yield put(toastSuccess('Save Contract success.'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Upload attachments contract fail.'))
    }
    yield put(appLoaded())
  }
}

function* getContractDetailRequest(action) {
  const { id, history, isEdit } = action.payload
  try {
    yield put(appLoading())
    let username = localStorage.getItem('username').toLowerCase()
    const response = yield httpGet(basePath(`${id}`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        let data = response.data
        let creater = data.createdByUser ? data.createdByUser.toLowerCase() : ''
        let requester = data.prRequester ? data.createdByUser.toLowerCase() : ''
        if (isEdit) {
          if ([0, 5, 9].indexOf(data.status) >= 0) {
            if (username == creater || username == requester) {
              yield put(getContractDetailSuccess(data))
            } else {
              yield put(appLoaded())
              history.push(contractDetailPath(data.id))
            }
          } else {
            yield put(appLoaded())
            history.push(contractDetailPath(data.id))
          }
        } else {
          if ([0, 5, 9].indexOf(data.status) >= 0) {
            if (username == creater || username == requester) {
              yield put(appLoaded())
              history.push(contractEditPath(data.id))
            } else {
              yield put(getContractDetailSuccess(data))
            }
          } else {
            yield put(getContractDetailSuccess(data))
          }
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getContractDetail(id, history, isEdit))
    } else {
      if (e && e.data && e.data.message) {
        yield put(toastError(e.data.message))
      } else {
        yield put(toastError('Load contract data error!'))
      }
    }
  }
}

function* fetchPOCompleteRequest(action) {
  const { dataSearch } = action.payload
  try {
    const response = yield httpGet('options/getPurchaseOrderComplete', dataSearch)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchPOCompleteSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(fetchPOCompleteSuccess({ data: [] }))
  }
  // const { poId } = action.payload
  // try {
  //   yield put(appLoading())
  //   const response = yield httpGet('options/getPurchaseOrderComplete',{poId:poId})
  //   if (response.status >= 200 && response.status < 300) {
  //     if (response.data) {
  //       yield put(fetchPOCompleteSuccess(response.data.map((x)=>({value:x.id, text:`${x.sapNumber}|${x.documentNumber}|${x.title}`}))))
  //     }
  //   }
  //   yield put(appLoaded())
  // } catch (e) {
  //   yield put(fetchPOCompleteSuccess([]))
  //   yield put(appLoaded())
  // }
}

function* gethPOCompleteDetailRequest(action) {
  const { poId } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(basePath(`getPurchaseOrderdetail/${poId}`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(gethPOCompleteDetailSuccess(response.data))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(gethPOCompleteDetail(poId))
    } else {
      yield put(toastError('Can\'t get Purchase Order detail'))
      yield put(gethPOCompleteDetailSuccess({}))
    }
  }
}

function* gethOptionContractRequest() {
  try {
    yield put(appLoading())
    const response = yield httpGet('options/getContractOption/Contract')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(gethOptionContractSuccess(response.data.map((x) => ({ value: x.code, text: x.name }))))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(gethOptionContractSuccess([]))
    yield put(appLoaded())
  }
}

function* gethOptionTypeOfContractRequest() {
  try {
    yield put(appLoading())
    const response = yield httpGet('options/getContractOption/TypeOfContract')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(gethOptionTypeOfContractSuccess(response.data.map((x) => ({ value: x.code, text: x.name }))))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(gethOptionTypeOfContractSuccess([]))
    yield put(appLoaded())
  }
}

function* gethOptionAOPTRequest() {
  try {
    yield put(appLoading())
    const response = yield httpGet('options/getContractOption/PaymentType')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(gethOptionAOPTSuccess(response.data.map((x) => ({ value: x.code, text: x.name }))))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(gethOptionAOPTSuccess([]))
    yield put(appLoaded())
  }
}

function* getContractWorkflowViewModeRequest(action) {
  const { contractId } = action.payload
  try {
    const response = yield httpGet(basePath('workflowApproverViewMode'), { contractId: contractId })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getContractWorkflowViewModeSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getContractWorkflowViewMode(contractId))
    } else {
      yield put(getContractWorkflowViewModeSuccess([]))
    }
  }
}

function* getContractWorkflowEditModeRequest(action) {
  const { data } = action.payload
  try {
    const response = yield httpGet(basePath('workflowApproverEditMode'), data)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getContractWorkflowEditModeSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getContractWorkflowEditModeSuccess([]))
  }
}

function* deleteContractRequest(action) {
  const { contractId, history } = action.payload
  try {
    yield put(appLoading('Delete contract'))
    const response = yield httpDelete(basePath(contractId))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(appLoaded())
        history.push(contractPath)
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Delete contract fail!'))
    }
    yield put(appLoaded())
  }
}

function* approveActionContractRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(basePath(`${data.docId}/actionApproval`), data, multipartHeader)
    if (response.status >= 200 && response.status < 300) {
      if (history.location.search.includes('h=true')) {
        yield put(appLoaded())
        history.push(homePath)
      } else {
        yield put(appLoaded())
        history.push(contractPath)
      }
      yield put(toastSuccess('Action Contract success.'))
    }
  } catch (e) {
    yield put(toastError('Action Contract fail.'))
    yield put(appLoaded())
  }
}

export function* watchContractSaga() {
  yield takeLatest(FETCH_CONTRACT.REQUEST, fetchContractRequest)
  yield takeLatest(CREATE_CONTRACT, createContractRequest)
  yield takeLatest(UPDATE_CONTRACT, updateContractRequest)
  yield takeLatest(SUBMIT_CONTRACT, submitContractRequest)
  yield takeLatest(CHECKED_CONTRACT, checkedContractRequest)
  yield takeLatest(RESUBMIT_CONTRACT, resubmitContractRequest)
  yield takeLatest(UPLOAD_ATTACHMENTS_CONTRACT, uploadAttachmentsContractRequest)
  yield takeLatest(GET_CONTRACT_DETAIL.REQUEST, getContractDetailRequest)
  yield takeLatest(FETCH_PO_COMPLETE_FOR_CONTRACT.REQUEST, fetchPOCompleteRequest)
  yield takeLatest(GET_PO_COMPLETE_DETAIL_FOR_CONTRACT.REQUEST, gethPOCompleteDetailRequest)
  yield takeLatest(GET_OPTION_CONTRACT.REQUEST, gethOptionContractRequest)
  yield takeLatest(GET_OPTION_TYPE_OF_CONTRACT.REQUEST, gethOptionTypeOfContractRequest)
  yield takeLatest(GET_OPTION_AMOUNT_OF_PAYMENT_TYPE.REQUEST, gethOptionAOPTRequest)
  yield takeLatest(GET_CONTRACT_WORKFLOW_VIEW_MODE.REQUEST, getContractWorkflowViewModeRequest)
  yield takeLatest(GET_CONTRACT_WORKFLOW_EDIT_MODE.REQUEST, getContractWorkflowEditModeRequest)
  yield takeLatest(DELETE_CONTRACT, deleteContractRequest)
  yield takeLatest(APPROVE_ACTION_CONTRACT, approveActionContractRequest)
}

const initial = {
  listContract: { data: {}, loading: false },
  contractDetail: { data: {}, loading: false },
  poCompleteList: { data: [], loading: false },
  poCompleteDetail: { data: {}, loading: false },
  poSelected: { data: {} },
  optionContract: { data: [], loading: false },
  optionTypeOfContract: { data: [], loading: false },
  optionAmountOfPaymentType: { data: [], loading: false },
  contractWorkflowData: { data: [], loading: false }
}

export default createReducer(initial, state => ({
  [CLEAR_CONTRACT_DATA]: () => ({
    ...state,
    poCompleteDetail: { data: {}, loading: false },
    contractDetail: { data: {}, loading: false },
    poSelected: { data: {} }
  }),
  [FETCH_CONTRACT.REQUEST]: () => ({
    ...state,
    listContract: { data: {}, loading: true }
  }),
  [FETCH_CONTRACT.SUCCESS]: (data) => ({
    ...state,
    listContract: { data: data.data, loading: false }
  }),
  [FETCH_CONTRACT.FAILURE]: () => ({
    ...state,
    listContract: { data: [], loading: false }
  }),
  [GET_CONTRACT_DETAIL.REQUEST]: () => ({
    ...state,
    contractDetail: { data: {}, loading: true }
  }),
  [GET_CONTRACT_DETAIL.SUCCESS]: (data) => ({
    ...state,
    contractDetail: { data: data.data, loading: false }
  }),
  [FETCH_PO_COMPLETE_FOR_CONTRACT.REQUEST]: () => ({
    ...state,
    poCompleteList: { data: [], loading: true }
  }),
  [FETCH_PO_COMPLETE_FOR_CONTRACT.SUCCESS]: (data) => ({
    ...state,
    poCompleteList: { ...data.data, loading: false }
  }),
  [GET_PO_COMPLETE_DETAIL_FOR_CONTRACT.REQUEST]: () => ({
    ...state,
    poCompleteDetail: { data: {}, loading: true }
  }),
  [GET_PO_COMPLETE_DETAIL_FOR_CONTRACT.SUCCESS]: (data) => ({
    ...state,
    poCompleteDetail: { data: data.data, loading: false }
  }),
  [GET_OPTION_CONTRACT.REQUEST]: () => ({
    ...state,
    optionContract: { data: [], loading: true }
  }),
  [GET_OPTION_CONTRACT.SUCCESS]: (data) => ({
    ...state,
    optionContract: { data: data.data, loading: false }
  }),
  [GET_OPTION_TYPE_OF_CONTRACT.REQUEST]: () => ({
    ...state,
    optionTypeOfContract: { data: [], loading: true }
  }),
  [GET_OPTION_TYPE_OF_CONTRACT.SUCCESS]: (data) => ({
    ...state,
    optionTypeOfContract: { data: data.data, loading: false }
  }),
  [GET_OPTION_AMOUNT_OF_PAYMENT_TYPE.REQUEST]: () => ({
    ...state,
    optionAmountOfPaymentType: { data: [], loading: true }
  }),
  [GET_OPTION_AMOUNT_OF_PAYMENT_TYPE.SUCCESS]: (data) => ({
    ...state,
    optionAmountOfPaymentType: { data: data.data, loading: false }
  }),
  [SELECT_PO]: (data) => ({
    ...state,
    poSelected: { data: data.data }
  }),
  [CLEAR_SEARCH_PO]: () => ({
    ...state,
    poCompleteList: { data: [], loading: false },
  }),
  [GET_CONTRACT_WORKFLOW_VIEW_MODE.REQUEST]: () => ({
    ...state,
    contractWorkflowData: { data: [], loading: true },
  }),
  [GET_CONTRACT_WORKFLOW_VIEW_MODE.SUCCESS]: (data) => ({
    ...state,
    contractWorkflowData: { data: data.data, loading: false }
  }),
  [GET_CONTRACT_WORKFLOW_EDIT_MODE.REQUEST]: () => ({
    ...state,
    contractWorkflowData: { data: [], loading: true },
  }),
  [GET_CONTRACT_WORKFLOW_EDIT_MODE.SUCCESS]: (data) => ({
    ...state,
    contractWorkflowData: { data: data.data, loading: false }
  }),
}))